<template>
    <NuxtLayout name="malt-full-layout">
        <slot />

        <template #admin-tools>
            <FooterAdminTools>
                <template #cta>
                    <VJoyButton size="small" target="_blank" href="/admin/dashboard/news" variant="admin">Dashboard News</VJoyButton>
                </template>
            </FooterAdminTools>
        </template>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {FooterAdminTools} from '#components';
    import {use3rdParties, useAmplitudeSessionReplay} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {VJoyButton} from '@maltjoy/core-vue';

    use3rdParties();

    const isAmplitudeRecordingEnabled = useFeatureFlag('amplitude-recording-for-freelancer-dashboard');
    useAmplitudeSessionReplay(() => isAmplitudeRecordingEnabled.value);
</script>
